<header>
  <div class="header-container">
    <div class="row w-100">
      <div class="col-12">
        
        <nav class="navbar align-items-stretch">
          <div class="navbar-brands">
            <a
              class="navbar-brand d-inline-block"
              routerLink="/"
            >
              <img
                src="/assets/images/identibase/identibase-logo.jpg"
                class="img-fluid"
                alt="identibase"
              />
            </a>
          </div>
          <app-unauthenticated-header
            *ngIf="!authManager.isAuthenticated"
          ></app-unauthenticated-header>
          <app-authenticated-header *ngIf="authManager.isAuthenticated"></app-authenticated-header>
        </nav>

      </div>
      <div *ngIf="purinaPartnerPage" class="partner-logo-container w-auto">
        <div class="partner-logo-container_text">in partnership with</div>
        <div class="partner-logo-container_logo">
          <img src="/assets/images/purina/purina-logo.png" class="img-fluid" alt="equevet pro" />
        </div>
      </div>
      <div *ngIf="bannersDetails && bannersDetails.length > 0" class="header-infoline">
        <div *ngFor="let bannerDetail of bannersDetails">
          <div class="header-infoline-body" *ngIf="bannerDetail.isEnabled">
            {{ bannerDetail.message }}
          </div>
        </div>
      </div>
      <div *ngIf="registrationFinished" class="trustbox-wrapper">
        <app-trustbox></app-trustbox>
      </div>
    </div>
  </div>
</header>
